var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Do not edit this file, it is auto generated
 */
import { StyledSvgIcon } from '../../styles/svg-icon.styled';
export const SocialXIcon = (_a) => {
    var { size = 'md' } = _a, props = __rest(_a, ["size"]);
    return (_jsx(StyledSvgIcon, Object.assign({ xmlSpace: "preserve", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", "$size": size }, props, { children: _jsx("path", { d: "m18.063 14.31 8.039-9.345h-1.905l-6.98 8.114-5.575-8.114h-6.43l8.431 12.27-8.431 9.799h1.905l7.371-8.569 5.888 8.569h6.43zm-2.609 3.033-.854-1.222L7.803 6.4h2.926l5.485 7.846.854 1.222 7.13 10.198h-2.926z" }) })));
};
